<template>
	<div class="pageTitle">
		<h1 class="ch">{{ ch }}</h1>
		<h1 class="en">{{ en }}</h1>
	</div>
</template>

<script>
export default {
	name: "pageTitle",
	data() {
		return {};
	},
	methods: {},
	props: {
		ch: String,
		en: String,
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../stylesheet/base.sass'
@import '../stylesheet/layout.sass'

.pageTitle
  +flexLayout('center', 'col')
  margin: 47px auto 15px auto
  .ch
    font-size: $font-size-1
    font-weight: 500
    margin-bottom: 12px

  .en
    font-size: $font-size-3
    font-weight: 200
		text-align: justify
		padding: 0 10px
</style>



// WEBPACK FOOTER //
// src/components/page_title.vue